import {
  Card,
  CardContent,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@design-system';

interface MetricCardProps {
  label: string;
  value: string | number;
  secondaryValue?: string | number;
  secondaryLabel?: string;
  description?: string;
  className?: string;
  valueClassName?: string;
  onClick?: () => void;
}

export function MetricCard({
  label,
  value,
  secondaryValue,
  secondaryLabel = 'all time',
  description,
  className = '',
  valueClassName = '',
  onClick,
}: MetricCardProps) {
  const content = (
    <Card
      className={`h-full border border-gray-200 shadow-sm ${onClick ? 'cursor-pointer transition-shadow hover:shadow-md' : ''} ${className}`}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-600">{label}</p>
            <p className={`mt-2 text-3xl font-bold text-gray-900 ${valueClassName}`}>{value}</p>
            {secondaryValue !== undefined && (
              <p className="mt-1 text-xs text-gray-700">
                {secondaryValue} {secondaryLabel}
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );

  if (description) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="h-full cursor-help">{content}</div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs">{description}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
